module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/214ca2d22751f17cf368c5231de4936f.gif";